import getters from './getters'
import mutations from './mutations'
import actions from './actions'
const state = {
  openSessionList: '',
  selectedSessionData: {},
  outlierSessionData: [],
  incompleteData: '',
  suspiciousMessages: '',
  completedSessionData: '',
  completedSessionLots: '',
  commonConsumptionHistory: {},
  adhocSessionData: '',
  adhocSessionLots: '',
  uploadSessionResponse: null,
  discardSession: null,
  billValue: '',
  totalBillableUnits: '',
  completeSessionDownloadData: {}
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sessions/index.js